import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useConfig } from 'wagmi'

import { getChainConfigEntry } from '@/config/chain'
import { usePageChainId } from '@/domain/hooks/usePageChainId'

export function usePrefetchSavingsGeneralStats(): void {
  const queryClient = useQueryClient()
  const { chainId } = usePageChainId()
  const wagmiConfig = useConfig()
  const chainConfig = getChainConfigEntry(chainId)

  useEffect(() => {
    for (const account of chainConfig.savings?.accounts ?? []) {
      const accountStatsQueryOptions = account.stats?.queryOptions?.({ wagmiConfig, chainId })
      if (accountStatsQueryOptions) {
        void queryClient.prefetchQuery(accountStatsQueryOptions)
      }
    }
  }, [queryClient, wagmiConfig, chainConfig, chainId])
}
